<template>
    <div class="update-substitution-mapping">
      <h3>Update Substitution Mapping</h3>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-4">
            <label for="qwilr-definition-field" class="form-label">Field</label>
            <input
              type="text"
              id="qwilr-definition-field"
              class="form-control"
              v-model="qwilrDefinitionField"
              disabled
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-4">
            <label for="qwilr-field" class="form-label">Qwilr Field</label>
            <input
                type="text"
                placeholder="Qwilr Field"
                id="qwilr-field"
                class="form-control"
                v-model="qwilrField"
                />
          </div>  
        </div>
      </div>

      <div class="form-buttons">
        <div class="row">
            <div class="col-md-12">
              <button class="btn btn-primary" @click="updateMapping" :disabled="isBusy">
                <div v-if="isBusy">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>

                      Loading...
                </div>
                <div v-else>
                  Update Mapping
                </div>
              </button>
              <button class="btn btn-secondary" @click="$emit('close')" style="margin-left: 5px;">Cancel</button>
            </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { UpdateQwilrSubstitutionMapping } from '@/core/services/entities/qwilr.service'
  import { useToast } from 'vue-toastification'

  export default{
    name:"UpdateQwilrSubstitutionMappingComponent",
    props:{
        mapping:{
            type:Object,
            required:true
        }
    },
    data(){
        return{
            qwilrField:'',
            qwilrDefinitionField:'',
            qwilrDefinitionFieldId:'',
            isBusy:false
        }
    },
    methods:{
        async updateMapping(){
            const toast = useToast();
            const elementType=1;
            const payload = { id:this.mapping.id, qwilrDefinitionFieldId:this.qwilrDefinitionFieldId, qwilrField:this.qwilrField};
            this.isBusy = true;

            setTimeout(async () => {
              if (!this.qwilrField || this.qwilrField.trim() === '') {
                toast.error('Qwir Field is required!', { timeout: 3000 });
                this.isBusy = false;
                return; 
              }

              await UpdateQwilrSubstitutionMapping(payload)
                      .then(response => {
                      if (response.status === 200) {
                          toast.success('Mapping updated successfully!', {
                          timeout: 2000
                          })
                          this.isBusy = false;
                          this.$emit('mappingUpdated'); // Emit the event to notify the parent component
                          this.$emit('close'); // Close the lightbox after adding data stream
                      }
                      })
                      .catch(ex => {
                          this.isBusy = false;
                          const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                          console.log(ex);
                          toast.error(`Failed to update mapping : ${errorMessage}`, {timeout: 2000,});
                      })
            },500);

        }
        

    },
    created() {
        this.qwilrField=this.mapping.qwilrField
        this.qwilrDefinitionField=this.mapping.field
        this.qwilrDefinitionFieldId=this.mapping.qwilrDefinitionFieldId
    }
  }
 </script>
  
  <style scoped>
  .update-substitution-mapping {
    width: 900px; /* Double the size */
    height: 300px; /* Double the size */
    padding: 40px; /* Increase padding */
    background-color: #fff; /* Ensure background is white */
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .form-group {
    margin-bottom: 1rem;
  }
  
  .form-label {
    display: block;
    margin-bottom: 0.5rem;
  }
  
  .form-control {
    width: 100%;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
  }
  
  .form-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
  }
  
  .btn {
    padding: 0.5rem 1rem;
  }
  
  .btn-secondary {
    background-color: #6c757d;
    color: #fff;
  }
  
  .btn-secondary:hover {
    background-color: #5a6268;
  }
  </style>
  